import React, { useEffect, useState } from "react";
import ProgramCard from "domains/programs/components/Program/components/Card";
import LangContext from "domains/programs/langContext";
import withLanguageContext from "lib/hocs/withLanguageContext";
import { GET } from "lib/api";
import config from "lib/config";
import * as CONSTANTS from "./constants";
import SettingStore from "stores/settings";
import { StyledProgram } from "domains/programs/components/Program/style";
import { StyledCardContainer, StyledProgramOverviewCard } from "./style";

const RecommendedLearningActivities = (props) => {
  const { languageContext } = props;

  const [courses, setCourses] = useState([]);
  const onRefresh = () => {};
  const displayCardImage =
    SettingStore.getSettingValue(
      CONSTANTS.SYSTEM_SETTING_SHOW_COURSE_IMAGE_PORTAL,
    ) === CONSTANTS.SYSTEM_SETTING_ON;

  useEffect(() => {
    async function fetchData() {
      const data = await GET("v1/user/recommended/learnings?siteId=:siteId", {
        siteId: config.siteId,
      });

      setCourses(data);
    }
    fetchData();
  }, []);

  return (
    <LangContext.Provider value={languageContext}>
      <StyledProgram style={{ padding: 0 }} id="recommendedLearningActivities">
        <div className="panel-header">
          <h3 className="panel-heading">
            <span className="paneltitle">
              {languageContext("recommendedLearningActivities")}
            </span>
          </h3>
        </div>
        <StyledCardContainer className="container flex flex-wrap align-c">
          {courses.map((course, index) => {
            return (
              <StyledProgramOverviewCard key={`programoverviewcard${index}`}>
                <ProgramCard
                  course={course}
                  displayImage={displayCardImage}
                  activityId={index}
                  onRefresh={onRefresh}
                  isPortalOverview={true}
                />
              </StyledProgramOverviewCard>
            );
          })}
        </StyledCardContainer>
        <div className="flex flex-center">
          <a href={CONSTANTS.RECOMMENDED_COURSECATALOGUE_URL}>
            {languageContext("seeAllRecommended")}
          </a>
        </div>
      </StyledProgram>
    </LangContext.Provider>
  );
};

export default withLanguageContext(RecommendedLearningActivities, "Activities");
